import React from 'react';
import PropTypes from 'prop-types';
import VM from 'openblock-vm';
import CoreDownloadProgressComponent from '../components/core-download-progress/core-download-progress.jsx';

class CoreDownloadProgress extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            visible: false,
            percent: 0,
            label: ''
        };
        this.handleProgress = this.handleProgress.bind(this);
        this.handleComplete = this.handleComplete.bind(this);
    }

    componentDidMount () {
        this.props.vm.on('CORE_DOWNLOAD_PROGRESS', this.handleProgress);
        this.props.vm.on('CORE_DOWNLOAD_COMPLETE', this.handleComplete);
    }

    componentWillUnmount () {
        this.props.vm.removeListener('CORE_DOWNLOAD_PROGRESS', this.handleProgress);
        this.props.vm.removeListener('CORE_DOWNLOAD_COMPLETE', this.handleComplete);
    }

    handleProgress (data) {
        this.setState({
            visible: true,
            percent: data.percent || 0,
            label: data.label || ''
        });
    }

    handleComplete () {
        this.setState({percent: 100});
        // Auto-hide after 1.5 seconds
        setTimeout(() => {
            this.setState({visible: false, percent: 0, label: ''});
        }, 1500);
    }

    render () {
        if (!this.state.visible) return null;
        return (
            <CoreDownloadProgressComponent
                percent={this.state.percent}
                label={this.state.label}
            />
        );
    }
}

CoreDownloadProgress.propTypes = {
    vm: PropTypes.instanceOf(VM).isRequired
};

export default CoreDownloadProgress;
